import store from "@/store";

import lodashGet from "lodash/get";
import lodashHas from "lodash/has";

import { DEPLOY_ENV } from "@/common/config";
import { ENDPOINT_FEATURE_LOCK } from "@/common/constants/api";
import { GET_LOCKED_FEATURES } from "@/store/actions.type";
import { ENVIRONMENTS } from "@/common/constants/featureLock.config";
import { hasGroupByName } from "@/services/user/user.service";
import { httpGet } from "@/services/api.service";

export { _isFeatureUnlocked as isFeatureUnlocked };
export { _getLockedFeatures as getLockedFeatures };
export { _getAlertCountryLimit as getAlertCountryLimit };

const LOCKED_FEATURES_GETTER = "home/lockedFeatures";
const LOCKED_FEATURES_ACTION = "home/" + GET_LOCKED_FEATURES;

const _isFeatureUnlocked = (feature) => {
  let unlocked = true;
  const LOCKED_FEATURES = store.getters[LOCKED_FEATURES_GETTER];
  if (LOCKED_FEATURES && LOCKED_FEATURES.hasOwnProperty(feature)) {
    const FEATURE = LOCKED_FEATURES[feature];
    if (_isFeatureEnvLocked(FEATURE)) {
      unlocked = false;
      if (_isUserInExceptions(FEATURE)) {
        unlocked = true;
      }
    }
  }
  return unlocked;
};

const _getLockedFeatures = async () => {
  try {
    const RESULT = await httpGet({
      url: ENDPOINT_FEATURE_LOCK,
      noCache: true,
    });
    if (RESULT) {
      const { data } = JSON.parse(RESULT);
      if (data) {
        store.dispatch(LOCKED_FEATURES_ACTION, data);
      } else {
        console.error("No data for getLockedFeatures in featureLock.js");
      }
    } else {
      console.error("No RESULT for getLockedFeatures in featureLock.js");
    }
  } catch (error) {
    Promise.reject(
      "Issue getting locked features in featureLock.js: " +
        JSON.stringify(error)
    );
  }
};

const _isFeatureEnvLocked = (feature) => {
  const lockedEnv = feature.lockedEnv;
  if (lockedEnv) {
    const lockedIndex = ENVIRONMENTS.indexOf(lockedEnv);
    const envIndex = ENVIRONMENTS.indexOf(DEPLOY_ENV);
    if (lockedIndex === -1 || envIndex === -1) {
      //Mismatch on environment names
      return true;
    }
    /*
     * Environments are in order so that if test is locked, so is production.
     * But, dev and testWest will be unlocked
     */
    return envIndex >= lockedIndex;
  }
  return false;
};

const _isUserInExceptions = (feature) => {
  const exceptionGroups = feature.exceptionGroups;
  if (feature.hasOwnProperty("exceptionGroups")) {
    for (let i = 0; i < exceptionGroups.length; i++) {
      if (hasGroupByName(exceptionGroups[i])) {
        return true;
      }
    }
  }
  return false;
};

const _getAlertCountryLimit = () => {
  const LOCKED_FEATURES = store.getters[LOCKED_FEATURES_GETTER];

  if (lodashHas(LOCKED_FEATURES, "alert-country-count-limit.userGroupLimits")) {
    let groupLimits = lodashGet(
      LOCKED_FEATURES,
      "alert-country-count-limit.userGroupLimits"
    );
    for (var prop in groupLimits) {
      if (Object.prototype.hasOwnProperty.call(groupLimits, prop)) {
        if (hasGroupByName(prop)) {
          return groupLimits[prop];
        }
      }
    }
  }

  if (lodashHas(LOCKED_FEATURES, "alert-country-count-limit.defaultLimit")) {
    return lodashGet(LOCKED_FEATURES, "alert-country-count-limit.defaultLimit");
  }

  return 10;
};
